import { render, staticRenderFns } from "./NotenartDetail.vue?vue&type=template&id=a43e1a60&"
import script from "./NotenartDetail.vue?vue&type=script&lang=js&"
export * from "./NotenartDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports